export const HTMLSettings = require('./html/HTMLSettings').default;
export const StageSettings = require('./stage/StageSettings').default;
export const BoothLogoListSettings = require('./boothlogolist/BoothLogoListSettings.tsx').default;
export const PresentationPreviewListSettings = require('./presentationpreviewlist/PresentationPreviewListSettings').default;
export const BoothsSettings = require('./booths/BoothsSettings').default;
export const HeroMenuSettings = require('./heromenu/HeroMenuSettings').default;
export const MarginSettings = require('./margin/MarginSettings').default;
export const NetworkSettings = require('./network/NetworkSettings').default;
export const PresentationSettings = require('./presentation/PresentationSettings').default;
export const CTAButtonSettings = require('./ctabutton/CTAButtonSettings').default;
export const MediaSettings = require('./media/MediaSettings').default;
export const EventHomeSettings = require('./eventhome/EventHomeSettings').default;
export const InfoBoothSettings = require('./infobooth/InfoBoothSettings').default;
export const QueueSettings = require('./queue/QueueSettings').default;
export const GallerySettings = require('./gallery/GallerySettings').default; // deprecated and moved to image component
export const SignupFormSettings = require('./signupform/SignupFormSettings').default;
export const CountdownSettings = require('./countdown/CountdownSettings').default;
export const PhotoBoothSettings = require('./photobooth/PhotoBoothSettings').default;
export const VideoSettings = require('./video/VideoSettings').default;
export const SpeedDatingSettings = require('./speeddating/SpeedDatingSettings').default;
export const AllMatchesSettings = require('./allMatches/AllMatchesSettings').default;
export const TicketcodeSettings = require('./ticketcode/TicketcodeSettings').default;
export { default as AgendSettings } from './agenda/AgendaSettings';
export { default as ChallengeSettings } from './challenge/ChallengeSettings';
export { default as ColumnSettings } from './column/ColumnSettings';
export { default as DividerSettings } from './divider/DividerSettings';
export { default as EventsListSettings } from './eventslist/EventsListSettings';
export { default as ImageSettings } from './image/ImageSettings';
export { default as QASettings } from './qa/QASettings';
export { default as SocialMediaSettings } from './socialmedia/SocialMediaSettings';
export { default as SpeakersSettings } from './speakers/SpeakerSettings';
export { default as TeamHeroMenuSettings } from './teamheromenu/TeamHeroSettings';
export { default as UserProfileSettings } from './userprofile/UserProfileSettings';
